
const defaultColorStops = [
  // [0, 'rgba(246,107,238,1)'],
  [0, 'rgb(255,98,247, 0.85)'],
  // [0.9, 'rgba(74, 16, 139, 0.9)'],
  // [1, 'rgba(74, 16, 139, 0.9)']
  // [0.99, 'rgba(57, 16, 139, 0.9)'],
  [1, 'rgba(74, 16, 139, 0.85)'],
  // [1, 'rgba(57, 16, 139,1)'],

]
export function createGradientTexture(textureWidth, textureHeight, stopColors = defaultColorStops) {
  const canvas = document.createElement('canvas');
  canvas.width = textureWidth;
  canvas.height = textureHeight;

  const ctx = canvas.getContext('2d');
  const grd = ctx.createLinearGradient(0, 0, textureWidth, 0);

  stopColors.forEach(colorStop => {
    grd.addColorStop(...colorStop)
  })

  ctx.fillStyle = grd;
  ctx.fillRect(0, 0, textureHeight, textureWidth);
  return PIXI.Texture.from(canvas);
}
